// Copyright (c) Move Closer 2022.

import { Module } from 'vuex'

import { SharedState, State } from './contracts/store'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const storeFactory = (): Module<SharedState, State> => ({
  namespaced: true,

  state: () => ({
    applyingFilters: false,
    applyMethod: null,
    filterParams: [],
    hasTopBar: false,
    loyalty: null,
    trustedShopAggregateRating: null
  }),

  actions: {
    applyFilters ({ state }, filters) {
      if (state.applyMethod) {
        return state.applyMethod(filters)
      }
    }
  },

  mutations: {
    setApplyMethod (state, method) {
      state.applyMethod = method
    },
    setFilterParams (state, params) {
      state.filterParams = params ?? []
    },
    setHasTopBar (state, payload) {
      state.hasTopBar = payload
    },
    setTrustedShopAggregateRating (state, payload) {
      state.trustedShopAggregateRating = payload
    },
    setLoyalty (state, payload) {
      state.loyalty = payload
    },
    toggleFiltersState (state, applying) {
      state.applyingFilters = applying
    }
  },

  getters: {
    areFiltersApplying: state => state.applyingFilters,
    getFilterParams: state => state.filterParams ?? [],
    getHasTopBar: state => state.hasTopBar,
    getTrustedShopAggregateRating: state => state.trustedShopAggregateRating,
    getLoyalty: state => state.loyalty
  }
})
